export default __webpack_public_path__ + "static/media/sharp.4dd803c6.svg";